<ol
  class="grid w-full gap-4"
  [cdkDropListData]="sortedItems()"
  [attr.aria-label]="
    'Ordered list with ' +
    sortedItems().length +
    ' items' +
    (selectable() ? '. Items are selectable. Use Ctrl/Cmd + Arrow keys to reorder selected items.' : '')
  "
  [attr.role]="selectable() ? 'listbox' : null"
  (cdkDropListDropped)="onDrop($event)"
  cdkDropList
>
  @for (item of sortedItems(); track trackByKey($index, item)) {
    @let idIsNull = item['id'] === 'null';
    @let canDrag = item[orderField()] !== undefined && !idIsNull;
    <li
      class="group/card relative flex gap-4 hover:cursor-grab"
      [class.disabled]="disabled()"
      [class.selected]="selectable() && isItemSelected(item)"
      [class.selectable]="selectable() && !disabled()"
      [cdkDragData]="item"
      [cdkDragDisabled]="!canDrag"
      [attr.aria-label]="'Item ' + ($index + 1) + ' of ' + sortedItems().length"
      [attr.aria-describedby]="
        (showDragHandle() && !disabled() ? 'drag-instructions ' : '') +
        (selectable() && !disabled() ? 'keyboard-instructions' : '')
      "
      [attr.aria-selected]="selectable() ? isItemSelected(item) : null"
      [attr.role]="selectable() ? 'option' : null"
      [attr.tabindex]="selectable() && !disabled() ? '0' : null"
      [hlmContextMenuTrigger]="menu"
      [hlmContextMenuTriggerData]="{ $implicit: { data: item } }"
      [class]="{ 'hover:cursor-grab': canDrag }"
      (contextmenu)="onContextmenuTrigger(item, $event)"
      (click)="onItemClick(item, $event)"
      (keydown.enter)="onItemClick(item, $event)"
      (keydown.space)="onItemClick(item, $event); $event.preventDefault()"
      cdkDrag
    >
      @if (showDragHandle() && !disabled() && canDrag) {
        <div
          class="absolute top-0 -left-6 hidden group-hover/card:block"
          [attr.aria-label]="'Drag to reorder item ' + ($index + 1)"
          [attr.aria-describedby]="'drag-instructions'"
          cdkDragHandle
          role="button"
          tabindex="0"
        >
          <ng-icon class="my-2" name="lucideGripVertical" aria-hidden="true" />
        </div>
      }

      <div class="flex-1" aria-label="Item content">
        @if (itemTemplate() && !idIsNull) {
          <ng-container
            *ngTemplateOutlet="
              itemTemplate()!;
              context: { $implicit: item, index: $index, isSelected: isItemSelected(item) }
            "
          />
        } @else if (idIsNull) {
          <ng-container *ngTemplateOutlet="newItemTemplate()" />
        } @else {
          <ng-content select="[slot=item-content]">
            <!-- Fallback: display item as JSON if no content provided -->
            <div class="default-item-display">
              <pre>{{ item | json }}</pre>
            </div>
          </ng-content>
        }
      </div>
    </li>
  }

  @if (sortedItems().length === 0) {
    <li class="empty-state" role="status" aria-live="polite">
      <ng-content select="[slot=empty-state]">
        <div class="default-empty-state">
          <p class="paragraph-medium-medium text-grey-6">No items to display</p>
        </div>
      </ng-content>
    </li>
  }
</ol>

@if (selectable() && !disabled()) {
  <div class="sr-only" id="keyboard-instructions">
    Use Ctrl+Arrow Up to move selected item up, Ctrl+Arrow Down to move selected item down. On Mac, use Cmd instead of
    Ctrl.
  </div>
}

<ng-template #menu let-ctx>
  <hlm-dropdown-menu class="w-64">
    <hlm-dropdown-menu-group>
      @for (action of menuActions; track action.label) {
        <button [disabled]="!action.enabled()" (click)="action.execute()" hlmDropdownMenuItem>
          {{ action.label }}
          <hlm-dropdown-menu-shortcut>{{ action.shortcut }}</hlm-dropdown-menu-shortcut>
        </button>
      }
    </hlm-dropdown-menu-group>
    @for (group of actionsGroups(); track $index) {
      <hlm-dropdown-menu-separator />
      <hlm-dropdown-menu-group>
        @for (action of group; track action.label) {
          <button [disabled]="!action.enabled(ctx.data)" (click)="action.execute(ctx.data)" hlmDropdownMenuItem>
            {{ action.label }}
            @if (action.shortcut) {
              <hlm-dropdown-menu-shortcut>{{ action.shortcut }}</hlm-dropdown-menu-shortcut>
            }
          </button>
        }
      </hlm-dropdown-menu-group>
    }
  </hlm-dropdown-menu>
</ng-template>
